export default {
  appName: "GESTÃO DE FROTA",
  urlImages: "https://api.gestaodefrota.net.br/uploads/",
  menu: {
    drawer: true,
  },
  loader: false,
  modules: [
    { name: "prefectures", nome: "prefeituras" },
    { name: "prefectures", nome: "prefeituras c/ almoxarifado" },
    { name: "drivers", nome: "motoristas" },
    { name: "providers", nome: "fornecedores" },
    { name: "attendants", nome: "frentistas" },
  ],
  userData: [],
  userPermissions: [],
};
